import React, { useState } from 'react';
import PropTypes from 'prop-types';
import UiKitButton from 'components/UiKit/Button';
import PopupMenu from 'components/UiKit/PopupMenu';
import { Dropdown } from 'antd';
import { MASSIVE_CHANGE_SUMMARY } from 'reducers/reducer';
import { getCropZonesOnly } from 'screens/Property/PropertiesLanding/helpers/massAssigner';
import TagsModal from 'components/Modals/TagsModal';
import './index.css';

const massAssignerActionsDefaultPropFieldsToMassiveAssign = [];
const MassAssignerActions = ({
  fieldsToMassiveAssign = massAssignerActionsDefaultPropFieldsToMassiveAssign,
  dispatch,
  setOpenAddCropZonesModal
}) => {
  const [updatedTags] = useState([]);
  const [openTags, setOpenTags] = useState(false);

  const handleAction = (action, extraData = {}) => {
    dispatch({
      type: MASSIVE_CHANGE_SUMMARY,
      payload: {
        action,
        ...extraData
      }
    });
  };

  const hasCropZones = fieldsToMassiveAssign.some(fd => fd.cropzones.length);

  const buildCropZonesMenuItems = items =>
    items.map(item => ({
      key: item.key,
      disabled: item.disabled,
      label: (
        <button
          type="button"
          disabled={item.disabled}
          className="flex items-center text-left w-full border-none px-3 py-2 bg-transparent transition-colors mass-assigner-menu-item-container"
          style={{
            color: item.disabled ? '#9CA3AF' : '#1F2937',
            cursor: item.disabled ? 'not-allowed' : 'pointer'
          }}
          onMouseEnter={e => {
            if (!item.disabled) {
              e.currentTarget.style.backgroundColor = '#F3F4F6';
            }
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          {item.label}
        </button>
      ),
      onClick: item.onClick
    }));

  const cropZonesMenuItems = buildCropZonesMenuItems([
    {
      key: 'add-crop-zones',
      label: 'Add Crop Zones',
      onClick: () => {
        handleAction('Added');
        setOpenAddCropZonesModal(true);
      }
    },
    {
      key: 'change-crop-zones',
      label: 'Change Crop Zones',
      disabled: !hasCropZones,
      onClick: () => {
        handleAction('Changed');
        setOpenAddCropZonesModal(true);
      }
    },
    {
      key: 'delete-crop-zones',
      label: 'Delete Crop Zones',
      disabled: !hasCropZones,
      onClick: () =>
        handleAction('Deleted', {
          fieldsToMassiveAssign: getCropZonesOnly(fieldsToMassiveAssign)
        })
    }
  ]);

  const handleAddTags = flags => {
    dispatch({
      type: MASSIVE_CHANGE_SUMMARY,
      payload: {
        action: 'TagsAdded',
        flags,
        fieldsToMassiveAssign: getCropZonesOnly(fieldsToMassiveAssign)
      }
    });
  };

  const handleDeleteTags = flags => {
    dispatch({
      type: MASSIVE_CHANGE_SUMMARY,
      payload: {
        action: 'TagsDeleted',
        flags,
        fieldsToMassiveAssign: getCropZonesOnly(fieldsToMassiveAssign)
      }
    });
  };

  return (
    <div className="sticky bottom-0 w-full h-16 bg-white border-t-2 py-3 px-5 flex justify-between items-center z-4">
      <TagsModal
        open={openTags}
        close={() => {
          setOpenTags(false);
        }}
        name="Tags"
        selectedTags={updatedTags?.reduce((tagIds, tag) => {
          return `${tagIds},${tag.id}`;
        }, '')}
        returnSelectedTags={handleAddTags}
      />
      <div className="w-1/2 pr-2">
        <PopupMenu
          className="popup-width-mass-assigner"
          trigger={
            <UiKitButton
              variant="outline"
              size="lg"
              disabled
              style={{ width: '100%' }}
            >
              Edit Tags
            </UiKitButton>
          }
        >
          <PopupMenu.List>
            <PopupMenu.Item
              onClick={() => {
                setOpenTags(true);
              }}
            >
              <span
                className={`${
                  hasCropZones ? 'hover:font-semibold' : 'pt-1'
                } w-full h-full flex items-center`}
              >
                Add Tags
              </span>
            </PopupMenu.Item>
            <PopupMenu.Item
              onClick={() => {
                handleDeleteTags(updatedTags);
              }}
            >
              <span className="hover:font-semibold w-full h-full flex items-center">
                Delete Tags
              </span>
            </PopupMenu.Item>
          </PopupMenu.List>
        </PopupMenu>
      </div>
      <div className="w-1/2 pl-2">
        <Dropdown
          menu={{ items: cropZonesMenuItems }}
          trigger={['click']}
          placement="topRight"
          overlayClassName="mass-assigner-crop-zones-dropdown"
          overlayStyle={{ zIndex: 40 }}
        >
          <UiKitButton
            variant="primary"
            ghost
            size="lg"
            style={{ width: '100%' }}
            disabled={!fieldsToMassiveAssign.length}
          >
            Edit Crop Zones
          </UiKitButton>
        </Dropdown>
      </div>
    </div>
  );
};

MassAssignerActions.propTypes = {
  fieldsToMassiveAssign: PropTypes.arrayOf(PropTypes.object),
  setOpenAddCropZonesModal: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default MassAssignerActions;
